import { Tabs } from "antd";
import styles from "./subjects-view-tabs.module.css";    
import AcademicView from "../academic-view/academic-view";
import NonAcademicActivity from "../non-academic-activity/non-academic-activity";
import { useSelector } from "react-redux";

export function SubjectsViewTabs() { 
  const userDetails = useSelector((state) => state.user?.user);

  const items = [
    {
      key: "1",
      label: "Academic View",
      children: <AcademicView />,
    },
    {
      key: "2",
      label: "Nonacademic View",
      children: <NonAcademicActivity institutionId={userDetails?.institution_id} />,
    },
  ]; 

  return (
    <div className={styles.subjects_view_tabs}>
      <Tabs
        default="1"
        items={items}
        tabBarStyle={{ borderBottom: "none" }} 
      /> 
    </div>
  );
}

export default SubjectsViewTabs;
